import React from "react"

export const ArrowSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2 4L13.456 6.41714L6.128 14.2857H32V17.7143H6.128L13.472 25.5829L11.2 28L0 16L11.2 4Z"
      fill="#323232"
    />
  </svg>
)
